import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaOrdenesdePagosDevolver from "./tablaOrdenesPagoDevolver";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Input } from "../../ui/inputs/Input";

export const DevolverOrdenPago = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];
      let validad = [];
      if (operacion === 1) {
        datos.push({
          nid: 0,
          fec: txtFecha.current.value,
          obser: txtObservacion.current.value.trim(),
          tip: parseInt(ticomp),
          depart: parseInt(depart),
          idefi: idefiscal,
          devol: tip,
          aprob: true,
        });
        for (let e = 0; e < data.length; e++) {
          datost.push({
            nid: 0,
            motiv: data[e].motivo,
            idorden: data[e].idordenpago,
            conce: data[e].concepto,
            idapro: 0,
            tip: parseInt(data[e].tipo),
          });
        }
        for (let i = 0; i < data.length; i++) {
          validad.push({
            idordencs: data[i].idordenpago,
            idefis: idefiscal,
            val: data[i].tipo,
          });
        }
      }

      setBody({
        operacion: 1,
        nid: txtCodigo.current.value !== "" ? txtCodigo.current.value : 0,
        fec: txtFecha.current.value,
        obser: txtObservacion.current.value,
        tip: 1,
        depart: 4,
        idefi: idefiscal,
        devol: 0,
        aprob: true,
      });
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Devolver estos Documentos?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const ActualizarDetalle = (id) => {
    let endpoint = `${op.conexion}/api/administracion/detalleaprobacionact2`;
    setActivate(true);
    let body = {
      idapro: id,
      tipocom: props.tip,
      ordenes: data,
      idefi: idefiscal,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          // console.log(response.data)
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Devolucion Exitosa",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/aprobacionesact2`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            ActualizarDetalle(response.data[0].aprobaciones_act2);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setActivo(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    if (data.length > 0) {
      setActivo(false);
      setValida(1);
    } else {
      setActivo(true);
      setValida(0);
    }
    setData(data);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.aprobaciones);
          setDatospre(props.aprodetalle);
          if (props.aprobado === true) {
            if (props.tip === 0) {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento ya fué Devuelto a Administración !
                </p>
              );
            } else {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento ya fué Devuelto a Tesorería !
                </p>
              );
            }
          } else {
            setTituloapro(
              <p className="text-success text-center">
                ¡ El Documento esta por Enviar a Administración !
              </p>
            );
          }
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtCodigo.current.value = "";
          if (props.ubi === 44) {
            setDepart(4);
            setUbi(44);
            setTip(0);
            setTicomp(1);
          }
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 4
            ? "Consulta. Unidad de Tesorería - " + props.titulo
            : operacion === 2
            ? "Unidad de Tesorería - " + props.titulo
            : operacion === 3
            ? "Unidad de Tesorería - " + props.titulo
            : "Unidad de Tesorería - " + props.titulo}
        </h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div >
          <input type="hidden" ref={txtNp} />
          <fieldset className="col-12 border-azul rounded d-flex flex-wrap justify-content-between">
            <legend className="float-none m-0 w-auto">Datos</legend>
            <div className="col-3 col-lg-2 p-0 m-0">
              <Input
                label="Código:"
                name="observacion"
                disabled={true}
                defaultValue={
                  props.aprobaciones
                    ? props.aprobaciones.idaprobaciones.trim()
                    : ""
                }
                id="inputDireccion"
                ref={txtCodigo}
              />
            </div>

            <div className="col-4 col-lg-2 m-0 p-0 pl-2">
              <Input
                label="Fecha:"
                type="date"
                disabled={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                defaultValue={
                  props.aprobaciones && props.aprobaciones.fecha !== ""
                    ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                id="inputDireccion"
                ref={txtFecha}
              />
            </div>
            <div className="col-12 p-0 m-0 mt-1">
                <Input label = 'Observación:'
                    name="observacion"
                    onChange={onChange}
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultValue={
                        props.aprobaciones
                        ? props.aprobaciones.observaciones.trim()
                        : ""
                    }
                    placeholder="Descripción de la Observación"
                    id="inputDireccion"
                    ref={txtObservacion}
                />
            </div>
          </fieldset>
          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">
              Detalle de las Ordenes de Pago
            </legend>
              <TablaOrdenesdePagosDevolver
                data={BaseDatos}
                datarecords={datospre}
                operacion={operacion}
              />
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {operacion === 2 ? (
          <InfoButton icon="fa-print">Imprimir</InfoButton>
        ) : (
          <SuccessButton onClick={onChangeValidar} disabled={activo}>
            Aceptar
          </SuccessButton>
        )}
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
